
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/es-co/ia/auditoria-cargas",
      function () {
        return require("private-next-pages/es-co/ia/auditoria-cargas/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/es-co/ia/auditoria-cargas"])
      });
    }
  